import { CRMSelectAllOptions, ObjectType, SingleRowAction } from '@galaxy/crm/static';
import { ListActionsService } from './list-actions.service';
import { MultiRowAction } from '@galaxy/crm/static';
import { Row } from '@vendasta/galaxy/table';

export function AddToListSingleRowAction(
  namespace: string,
  service: ListActionsService,
  objectType: ObjectType,
  label: string,
): SingleRowAction {
  return {
    label: label,
    callback: (row: Row) => {
      service.addToList(namespace, objectType, [row]);
    },
  };
}

export function AddToListMultiRowAction(
  namespace: string,
  service: ListActionsService,
  objectType: ObjectType,
  label: string,
): MultiRowAction {
  return {
    label: label,
    callback: (rows: Row[]) => {
      service.addToList(namespace, objectType, rows);
    },
  };
}

export function AddToListSelectAllAction(
  namespace: string,
  service: ListActionsService,
  objectType: ObjectType,
  label: string,
): MultiRowAction {
  return {
    label: label,
    callback: (rows: Row[], options?: CRMSelectAllOptions) => {
      service.addSelectAllToList(namespace, objectType, options);
    },
  };
}
